import moment from "moment";

// Backend stores dob as null when not provided. Legacy records may still
// carry the 1970-01-01 epoch default, which is also treated as "no DOB".
export const isEmptyDob = (dob) => {
  if (!dob) return true;
  const m = moment(dob);
  if (!m.isValid()) return true;
  const EPOCH = "1970-01-01";
  return (
    m.format("YYYY-MM-DD") === EPOCH ||
    m.clone().utc().format("YYYY-MM-DD") === EPOCH
  );
};

export const formatDob = (dob, format = "DD-MM-YYYY", empty = "---") =>
  isEmptyDob(dob) ? empty : moment(dob).format(format);

export const getAge = (dob, empty = "") =>
  isEmptyDob(dob) ? empty : moment().diff(moment(dob), "years");

export const formatMobile = (countryCode, mobileNo) =>
  [countryCode, mobileNo].filter(Boolean).join(" ");
